import React, { useEffect, useState } from "react";
import { Button, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import "./UploadFileOptiwe.scss";

export type FileInfo = {
    name: string;
    mimeType: string;
    url: string;
};

type RequiredTexts = {
    clickToUploadText: string;
    fileSuccessfullyUploadedText: string;
    fileErrorUploadText: string;
};
type Props = {
    setUploadedFileInfo: (info?: FileInfo) => void;
    translations?: RequiredTexts;
    serverUrl: string;
};

export default function UploadFileOptiwe({ setUploadedFileInfo, translations, serverUrl }: Props) {
    const [t, setT] = useState<RequiredTexts>({
        clickToUploadText: "Click to upload",
        fileSuccessfullyUploadedText: "File successfully uploaded",
        fileErrorUploadText: "Error uploading file",
    });

    useEffect(() => {
        if (translations) setT(translations);
    }, [translations]);

    const props = {
        name: "file",
        accept: ".pdf",
        withCredentials: true,
        multiple: false,
        maxCount: 1,
        action: `${serverUrl}/workspaces/current/files/`,
        onChange(info: any) {
            const { status } = info.file;
            if (status === "done") {
                const url = info.file.response.url;
                setUploadedFileInfo({
                    name: info.file.name,
                    mimeType: info.file.type!,
                    url,
                });
                message.success(t.fileSuccessfullyUploadedText);
            } else if (status === "removed") {
                setUploadedFileInfo();
            } else if (status === "error") {
                message.error(t.fileErrorUploadText);
            }
        },
    };

    return (
        <Upload {...props}>
            <Button className="opt-button--light" icon={<UploadOutlined />}>
                {t.clickToUploadText}
            </Button>
        </Upload>
    );
}
